import React from 'react';

const SwimmingPoolIcon = (props) => {
  return (
    <img
      alt="Basen"
      src="/static/images/icons/place_types/swimming_pool.svg"
      {...props}
    />
  );
};

export default SwimmingPoolIcon;
